import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, IToolUserActionParams, IToolUserApiListResponse, IToolUserMutationResponse, IToolUserSaveParams } from '@/types';
import { IToolUserBalanceResponse } from '@/types/api';

export const toolUserList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserApiListResponse>> => {
    return axios.get('/api/toolUser/list', { ...config, params });
};

export const toolUserDetailList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserApiListResponse>> => {
    return axios.get('/api/toolUserDetail/list', { ...config, params });
};

export const toolUserUpdate = (params: IToolUserSaveParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserMutationResponse>> => {
    return axios.post('/api/toolUser/update', params, config);
};

export const toolUserCreate = (params: IToolUserSaveParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserMutationResponse>> => {
    return axios.post('/api/toolUser/create', params, config);
};

export const toolUserSendVerifyEmail = (params: IToolUserActionParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserMutationResponse>> => {
    return axios.post('/api/toolUser/sendVerifyEmail', params, config);
};

export const toolUserSendActivationEmail = (params: IToolUserActionParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserMutationResponse>> => {
    return axios.post('/api/toolUser/sendActivationEmail', params, config);
};

export const toolUserSendApprovedNotification = (
    params: IToolUserActionParams,
    config?: AxiosRequestConfig
): Promise<AxiosResponse<IToolUserMutationResponse>> => {
    return axios.post('/api/toolUser/sendApprovedNotification', params, config);
};

export const toolUserDelete = (params: IToolUserActionParams, config?: AxiosRequestConfig): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/toolUser/delete', params, config);
};

export interface IToolUserPatchParams {
    rows: ({ id: number } & Record<string, unknown>)[];
}

export const toolUserPatch = (params: IToolUserPatchParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserMutationResponse>> => {
    return axios.post('/api/toolUser/update', params, config);
};

export const toolUserBalance = (toolUserId: number, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserBalanceResponse>> => {
    return axios.get('/api/toolUser/balance', { ...config, params: { id: toolUserId } });
};
